import React from 'react'
import { Link } from 'react-router-dom'
import Particles from 'react-tsparticles'
import ParticleConfig from '../../static/js/leadership.json'

import Arora from '../../static/images/team/arora.png'
import Rishi from '../../static/images/team/Rishishankar.jpg'
import Bansal from '../../static/images/team/bansal.png'
import Navbar from '../../components/navbar'

const Leadership = () => {
  return (
    <div className='section leadership'>
      <Navbar />
      <div className='leadership-opener'>
        <Particles options={ParticleConfig} style={{ position: 'absolute' }} />
        <div className='heading'>Leadership</div>
        <div className='sub-heading'>The Brains Behind Rean</div>
      </div>

      <div className='container'>
        <div className='row'>
          <div className='col-lg-3 col-md-6 leader'>
            <img src={Arora} />
            <div className='name'>Hitesh Arora</div>
            <div className='designation'>Managing Director and CEO</div>
            <a
              target='_blank'
              href='https://www.linkedin.com/in/hitesh-arora-b859b44/'
              className='linkedin'
            >
              <i class='bi bi-linkedin'></i>
            </a>
          </div>

          <div className='col-lg-3 col-md-6 leader'>
            <img src={Bansal} />
            <div className='name'>Rajesh Kumar Bansal</div>
            <div className='designation'>Independent Director</div>
            <a href='/leadership' className='linkedin'>
              <i class='bi bi-linkedin'></i>
            </a>
          </div>

          {/* <div className='col-lg-3 col-md-6 leader'>
            <img src={Rishi} />
            <div className='name'>Rishi Shankar Singh</div>
            <div className='designation'>Director</div>
            <a
              target='_blank'
              href='https://www.linkedin.com/in/rishishankar-singh-81658188/'
              className='linkedin'
            >
              <i class='bi bi-linkedin'></i>
            </a>
          </div> */}
        </div>
      </div>
    </div>
  )
}

export default Leadership
